import { useState, useEffect, useRef, useCallback } from "react";
import { getSupabase } from "./supabaseClient";
import tickettext from "./assets/ticket_text.svg";
import cardimg from "./assets/card-img.png";
import webqr from "./assets/web_qr.png";
import "./Ticket.css";
import CookieNotice from "./CookieNotice";

const generateBarcode = () =>
  Array.from({ length: 28 }, () => Math.floor(Math.random() * 10)).join("");

const formatDate = (d) =>
  d
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, ".");

const getDay = (d) =>
  d.toLocaleDateString("en-GB", { weekday: "long" }).toUpperCase();

const pad = (n) => String(n).padStart(5, "0");

const TICKET_RATIO = 2304 / 808;
const BASE_TICKET_WIDTH = 860;
const BASE_TICKET_HEIGHT = BASE_TICKET_WIDTH / TICKET_RATIO;
const SMALL_SCREEN_WIDTH = 850;

const FLIP_THRESHOLD = 80;
const PASS_ENTERED_KEY = "portfolio_ticket_done";
const REDIRECT_TO = "#/character-selection";
const SKIP_REDIRECT_TO = "#/featured-projects";
const TEAR_MS = 3600;
const MIN_SKELETON_MS = 1200;

function FlipIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8 7H4V3"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.8 7.2C6.2 4.6 8.9 3 12 3C16.4 3 20 6.6 20 11"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M16 17H20V21"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2 16.8C17.8 19.4 15.1 21 12 21C7.6 21 4 17.4 4 13"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function FrontFace({
  date,
  day,
  visitorCount,
  barcodeNumber,
  ticketNumber,
  isFlipped,
}) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        borderRadius: 18,
        overflow: "hidden",
        display: "flex",
        backgroundColor: "#fff",
        opacity: isFlipped ? 0 : 1,
        transition: "opacity 0.05s",
        pointerEvents: isFlipped ? "none" : "auto",
      }}
    >
      <img
        src={cardimg}
        alt="card pic"
        draggable="false"
        style={{
          zIndex: 4,
          left: "49%",
          top: "-21px",
          width: "auto",
          height: "107%",
          position: "relative",
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          position: "relative",
          zIndex: 2,
          left: "56%",
          transform: "rotate(-90deg)",
          top: "3px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "max-content",
          }}
        >
          <p
            style={{
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              padding: "4px 4px",
              borderRadius: 3,
              fontFamily: "'Outfit',sans-serif",
              marginTop: "-10px",
            }}
          >
            Viewer No. :<span style={{ opacity: 0.7 }}> #{pad(visitorCount)}</span>
          </p>
          <p
            style={{
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              padding: "4px 4px",
              borderRadius: 3,
              fontFamily: "'Outfit',sans-serif",
              marginTop: "-10px",
            }}
          >
            Access:{" "}
            <span style={{ opacity: 0.7 }}>
              Projects • Case Studies • Blogs
            </span>
          </p>
          <p
            style={{
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              padding: "4px 4px",
              borderRadius: 3,
              fontFamily: "'Outfit',sans-serif",
              marginTop: "-10px",
            }}
          >
            Access: <span style={{ opacity: 0.7 }}>Lifetime</span>
          </p>
        </div>

        <p
          style={{
            color: "#000",
            fontSize: "28px",
            fontWeight: 400,
            padding: "4px 4px",
            borderRadius: 3,
            fontFamily: "'Libre Barcode 128 Text', system-ui",
            marginTop: "-10px",
          }}
        >
          {barcodeNumber}
        </p>
      </div>

      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(118deg, transparent 30%, rgba(255,255,255,0.018) 50%, transparent 70%)",
          pointerEvents: "none",
          zIndex: 3,
        }}
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          zIndex: 1,
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            padding:
              "clamp(16px,3%,28px) clamp(16px,3%,32px) clamp(14px,2.5%,22px)",
            position: "relative",
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "clamp(12px,2.5%,24px)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 14,
              }}
            >
              <img
                src={tickettext}
                alt="Portfolio Pass"
                draggable="false"
                style={{ height: 28, width: "auto", display: "block" }}
              />
              <span
                style={{
                  color: "#000",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "4px 4px",
                  borderRadius: 3,
                  fontFamily: "'Outfit',sans-serif",
                  opacity: 0.7,
                }}
              >
                Individual Pass
              </span>
              <span
                style={{
                  color: "#000",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "4px 4px",
                  borderRadius: 3,
                  fontFamily: "'Outfit',sans-serif",
                  marginTop: "10px",
                }}
              >
                {date}
              </span>
              <span
                style={{
                  color: "#000",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "4px 4px",
                  borderRadius: 3,
                  fontFamily: "'Outfit',sans-serif",
                  textTransform: "capitalize",
                  marginTop: "-20px",
                }}
              >
                {day} 12am-12pm
              </span>
              <span
                style={{
                  color: "#000",
                  fontSize: "20px",
                  fontWeight: 600,
                  padding: "4px 4px",
                  borderRadius: 3,
                  fontFamily: "'Outfit',sans-serif",
                  marginTop: "40px",
                }}
              >
                Chennai,IND
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="ticket-perforation" />
    </div>
  );
}

function BackFace({
  date,
  day,
  visitorCount,
  barcodeNumber,
  ticketNumber,
  isFlipped,
}) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        borderRadius: 18,
        overflow: "hidden",
        backgroundColor: "#fff",
        transform: "scaleX(-1)",
        opacity: isFlipped ? 1 : 0,
        transition: "opacity 0.05s",
        pointerEvents: isFlipped ? "auto" : "none",
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
      }}
    >
      <div className="ticket-perforation2" />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          position: "relative",
          zIndex: 2,
          left: "-9%",
          transform: "rotate(90deg)",
          top: "6pc",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "max-content",
          }}
        >
          <p
            style={{
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              padding: "4px 4px",
              borderRadius: 3,
              fontFamily: "'Outfit',sans-serif",
              marginTop: "-10px",
            }}
          >
            Viewer No. :<span style={{ opacity: 0.7 }}> #{pad(visitorCount)}</span>
          </p>
          <p
            style={{
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              padding: "4px 4px",
              borderRadius: 3,
              fontFamily: "'Outfit',sans-serif",
              marginTop: "-10px",
            }}
          >
            Access:{" "}
            <span style={{ opacity: 0.7 }}>
              Projects • Case Studies • Blogs
            </span>
          </p>
          <p
            style={{
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              padding: "4px 4px",
              borderRadius: 3,
              fontFamily: "'Outfit',sans-serif",
              marginTop: "-10px",
            }}
          >
            Access: <span style={{ opacity: 0.7 }}>Lifetime</span>
          </p>
        </div>

        <p
          style={{
            color: "#000",
            fontSize: "28px",
            fontWeight: 400,
            padding: "4px 4px",
            borderRadius: 3,
            fontFamily: "'Libre Barcode 128 Text', system-ui",
            marginTop: "-10px",
          }}
        >
          {barcodeNumber}
        </p>
      </div>

      <img
        src={webqr}
        alt="Portfolio Pass"
        draggable="false"
        style={{
          height: "auto",
          width: "38%",
          display: "block",
          position: "relative",
          left: "32%",
          zIndex: 2,
        }}
      />

      <img
        src={cardimg}
        alt="card pic"
        draggable="false"
        style={{
          zIndex: 4,
          left: "-51%",
          top: "-21px",
          width: "auto",
          height: "107%",
          position: "relative",
          transform: "rotateY(180deg)",
        }}
      />
    </div>
  );
}

function TearingTicket({
  date,
  day,
  visitorCount,
  barcode,
  ticketNumber,
  isFlipped,
}) {
  const faceProps = {
    date,
    day,
    visitorCount,
    barcodeNumber: barcode,
    ticketNumber,
    isFlipped,
  };

  return (
    <div className="ticket-tear-layer">
      <div className="ticket-piece ticket-piece-left">
        <div className="ticket-piece-inner">
          <FrontFace {...faceProps} />
          <BackFace {...faceProps} />
        </div>
      </div>

      <div className="ticket-piece ticket-piece-right">
        <div className="ticket-piece-inner">
          <FrontFace {...faceProps} />
          <BackFace {...faceProps} />
        </div>
      </div>

      <div className="ticket-tear-perforation" />
      <div className="ticket-paper-fibers ticket-paper-fibers-left" />
      <div className="ticket-paper-fibers ticket-paper-fibers-right" />
      <div className="ticket-tear-head" />
      <div className="ticket-tear-glow" />
    </div>
  );
}

function TicketSkeleton({ ticketBoxStyle, ticketStageStyle }) {
  return (
    <div className="ticket-skeleton-wrap" style={ticketBoxStyle}>
      <div className="ticket-skeleton-stage" style={ticketStageStyle}>
        <div className="ticket-skeleton-card">
          <div className="ticket-skeleton-shine" />
        </div>
      </div>
    </div>
  );
}

export default function Ticket() {
  const today = new Date();
  const [date] = useState(() => formatDate(today));
  const [day] = useState(() => getDay(today));
  const [barcode] = useState(generateBarcode);
  const [ticketNumber] = useState(generateBarcode);
  const [visitorCount, setVisitorCount] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [isEntering, setIsEntering] = useState(false);
  const [isTicketLoading, setIsTicketLoading] = useState(true);
  const [viewport, setViewport] = useState(() => ({
    width: typeof window === "undefined" ? 1200 : window.innerWidth,
    height: typeof window === "undefined" ? 800 : window.innerHeight,
  }));

  const isSmallScreen = viewport.width < SMALL_SCREEN_WIDTH;

  const desktopWidth = Math.max(
    280,
    Math.min(BASE_TICKET_WIDTH, viewport.width - 48)
  );

  const preferredCompactScale = viewport.width <= 480 ? 0.48 : 0.6;
  const compactFitScale = Math.min(
    (viewport.width - 28) / BASE_TICKET_HEIGHT,
    (viewport.height - 220) / BASE_TICKET_WIDTH
  );

  const compactScale = Math.max(
    0.36,
    Math.min(preferredCompactScale, compactFitScale || preferredCompactScale)
  );

  const mobileScale = compactScale * 1.4;

  const ticketBoxStyle = isSmallScreen
    ? {
        width: `${BASE_TICKET_HEIGHT * mobileScale}px`,
        height: `${BASE_TICKET_WIDTH * mobileScale}px`,
      }
    : {
        width: `${desktopWidth}px`,
        height: `${desktopWidth / TICKET_RATIO}px`,
      };

  const ticketStageStyle = isSmallScreen
    ? {
        width: `${BASE_TICKET_WIDTH}px`,
        height: `${BASE_TICKET_HEIGHT}px`,
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: `translate(-50%, -50%) rotate(-90deg) scale(${mobileScale})`,
        transformOrigin: "center center",
      }
    : {
        width: `${desktopWidth}px`,
        height: `${desktopWidth / TICKET_RATIO}px`,
      };

  const [isBlocked] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(PASS_ENTERED_KEY) === "true";
  });

  const cardRef = useRef(null);
  const rotX = useRef(4);
  const rotY = useRef(-6);
  const targetX = useRef(4);
  const targetY = useRef(-6);
  const rotZ = useRef(0);
  const targetZ = useRef(0);
  const floatT = useRef(0);
  const rafId = useRef(null);
  const redirectTimer = useRef(null);
  const enteringRef = useRef(false);

  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartY = useRef(0);
  const dragStartRotX = useRef(0);
  const dragStartRotY = useRef(0);
  const totalDragX = useRef(0);

  const finishPass = useCallback(() => {
    localStorage.setItem(PASS_ENTERED_KEY, "true");
    window.location.replace(REDIRECT_TO);
  }, []);

  const enterPass = useCallback(() => {
    if (enteringRef.current) return;

    enteringRef.current = true;
    isDragging.current = false;
    setIsEntering(true);

    redirectTimer.current = window.setTimeout(finishPass, TEAR_MS);
  }, [finishPass]);

  const skipPass = useCallback(() => {
    if (enteringRef.current) return;
    window.location.replace(SKIP_REDIRECT_TO);
  }, []);

  useEffect(() => {
    if (isBlocked) window.location.replace(REDIRECT_TO);

    return () => {
      window.clearTimeout(redirectTimer.current);
    };
  }, [isBlocked]);

  useEffect(() => {
    targetZ.current = isFlipped ? 180 : 0;
  }, [isFlipped]);

  useEffect(() => {
    const check = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    let isMounted = true;
    let minDelayDone = false;
    let dataDone = false;

    const maybeFinish = () => {
      if (isMounted && minDelayDone && dataDone) {
        setIsTicketLoading(false);
      }
    };

    const minDelay = window.setTimeout(() => {
      minDelayDone = true;
      maybeFinish();
    }, MIN_SKELETON_MS);

    const fetchCount = async () => {
      const supabase = getSupabase();

      if (!supabase) {
        dataDone = true;
        maybeFinish();
        return;
      }

      const VISITOR_KEY = "portfolio_visitor_id";
      let visitorId = localStorage.getItem(VISITOR_KEY);
      const isNewVisitor = !visitorId;

      if (!visitorId) {
        visitorId = crypto.randomUUID();
        localStorage.setItem(VISITOR_KEY, visitorId);
      }

      try {
        const { data, error } = await supabase
          .from("page_views")
          .select("*")
          .eq("page", "portfolio")
          .maybeSingle();

        if (error) throw error;

        if (!data && isNewVisitor) {
          const { error: insertError } = await supabase
            .from("page_views")
            .insert([{ page: "portfolio", count: 1 }]);

          if (!insertError && isMounted) setVisitorCount(1);
          dataDone = true;
          maybeFinish();
          return;
        }

        if (data && isNewVisitor) {
          const newCount = data.count + 1;

          const { error: updateError } = await supabase
            .from("page_views")
            .update({ count: newCount })
            .eq("page", "portfolio");

          if (!updateError && isMounted) setVisitorCount(newCount);
          dataDone = true;
          maybeFinish();
          return;
        }

        if (data && isMounted) setVisitorCount(data.count);
      } catch (err) {
        console.error("Visitor count failed:", err.message);
      } finally {
        dataDone = true;
        maybeFinish();
      }
    };

    fetchCount();

    return () => {
      isMounted = false;
      window.clearTimeout(minDelay);
    };
  }, []);

  useEffect(() => {
    if (isTicketLoading) return;

    function tick() {
      if (!cardRef.current) {
        rafId.current = requestAnimationFrame(tick);
        return;
      }

      if (!enteringRef.current) {
        if (isSmallScreen) {
          targetX.current = 0;
          targetY.current = 0;
        } else if (!isDragging.current) {
          floatT.current += 0.007;
          const t = floatT.current;
          targetX.current = Math.sin(t * 0.8) * 3.5 + 3;
          targetY.current = Math.cos(t * 0.6) * 5 - 5;
        }

        const lerpSpeed = isDragging.current ? 1 : 0.05;
        rotX.current += (targetX.current - rotX.current) * lerpSpeed;
        rotY.current += (targetY.current - rotY.current) * lerpSpeed;

        const flipLerpSpeed = isDragging.current ? 1 : 0.08;
        rotZ.current += (targetZ.current - rotZ.current) * flipLerpSpeed;

        const tiltX = isSmallScreen ? 0 : rotX.current;
        const lift = isSmallScreen ? 18 : 22 + Math.abs(rotX.current) * 2.5;

        cardRef.current.style.transform = `perspective(1100px) rotateX(${tiltX}deg) rotateY(${rotZ.current}deg)`;
        cardRef.current.style.filter = [
          `drop-shadow(0 ${lift}px ${lift * 2}px rgba(0,0,0,0.95))`,
          "drop-shadow(0 6px 18px rgba(0,0,0,0.6))",
        ].join(" ");
      }

      rafId.current = requestAnimationFrame(tick);
    }

    rafId.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId.current);
  }, [isSmallScreen, isTicketLoading]);

  const onDragStart = useCallback(
    (clientX, clientY) => {
      if (isSmallScreen || enteringRef.current || isTicketLoading) return;

      isDragging.current = true;
      dragStartX.current = clientX;
      dragStartY.current = clientY;
      dragStartRotX.current = rotX.current;
      dragStartRotY.current = rotY.current;
      totalDragX.current = 0;
    },
    [isSmallScreen, isTicketLoading]
  );

  const onDragMove = useCallback(
    (clientX, clientY) => {
      if (
        isSmallScreen ||
        !isDragging.current ||
        enteringRef.current ||
        isTicketLoading
      ) {
        return;
      }

      const dx = clientX - dragStartX.current;
      const dy = clientY - dragStartY.current;
      totalDragX.current = dx;

      targetX.current = Math.max(
        -35,
        Math.min(35, dragStartRotX.current - dy * 0.35)
      );

      targetY.current = Math.max(
        -50,
        Math.min(50, dragStartRotY.current + dx * 0.35)
      );
    },
    [isSmallScreen, isTicketLoading]
  );

  const onDragEnd = useCallback(() => {
    if (
      isSmallScreen ||
      !isDragging.current ||
      enteringRef.current ||
      isTicketLoading
    ) {
      return;
    }

    isDragging.current = false;

    if (Math.abs(totalDragX.current) >= FLIP_THRESHOLD) {
      setIsFlipped((value) => !value);
    }

    totalDragX.current = 0;
  }, [isSmallScreen, isTicketLoading]);

  if (isBlocked) return null;

  return (
    <main
      className="ticket-page"
      onMouseMove={(e) => onDragMove(e.clientX, e.clientY)}
      onMouseUp={onDragEnd}
      onMouseLeave={onDragEnd}
    >
      <CookieNotice />

      <div className="ticket-page__inner">
        {isTicketLoading ? (
          <TicketSkeleton
            ticketBoxStyle={ticketBoxStyle}
            ticketStageStyle={ticketStageStyle}
          />
        ) : (
          <div className="ticket-scale-box" style={ticketBoxStyle}>
            <div className="ticket-stage" style={ticketStageStyle}>
              <div
                ref={cardRef}
                className="ticket-card-core"
                style={{
                  opacity: isEntering ? 0 : 1,
                  pointerEvents: isEntering ? "none" : "auto",
                }}
                onMouseDown={(e) => {
                  if (isSmallScreen || enteringRef.current) return;
                  e.preventDefault();
                  onDragStart(e.clientX, e.clientY);
                }}
              >
                <FrontFace
                  date={date}
                  day={day}
                  barcodeNumber={barcode}
                  visitorCount={visitorCount}
                  ticketNumber={ticketNumber}
                  isFlipped={isFlipped}
                />

                <BackFace
                  date={date}
                  day={day}
                  barcodeNumber={barcode}
                  visitorCount={visitorCount}
                  ticketNumber={ticketNumber}
                  isFlipped={isFlipped}
                />
              </div>

              {isEntering && (
                <TearingTicket
                  date={date}
                  day={day}
                  visitorCount={visitorCount}
                  barcode={barcode}
                  ticketNumber={ticketNumber}
                  isFlipped={isFlipped}
                />
              )}
            </div>
          </div>
        )}

        <div
          className={`ticket-controls ${
            isEntering || isTicketLoading ? "is-hidden" : ""
          }`}
        >
          <div className="ticket-controls__top">
            {!isSmallScreen && (
              <p className="ticket-hint">
                Drag left or right to flip · Tilt in any direction
              </p>
            )}

            <button
              className="ticket-btn ticket-btn-secondary ticket-btn-icon"
              type="button"
              aria-label="Flip ticket"
              onClick={() => setIsFlipped((value) => !value)}
            >
              <FlipIcon />
            </button>
          </div>

          <div className="ticket-action-row">
            <button
              className="ticket-btn ticket-btn-enter"
              type="button"
              onClick={enterPass}
            >
              Enter Pass
            </button>

            <button
              className="ticket-btn ticket-btn-secondary"
              type="button"
              onClick={skipPass}
            >
              Skip
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
